import errors from "./errors";

const errorsMessages = {
  [errors.COMMON_ERROR]: "Something went wrong! Please try again later.",
  [errors.SHIPPING_ZIP_NOT_VALID_ERROR]:
    "The postal code you've entered does not match the selected state. Please review your shipping details.",
};

export default errorsMessages;
